import styled from "styled-components";


export const AlbumDetailStyle = styled.div`
   .list{
      display: grid;
        gap:${(props) => props.theme.space.padding}px;
   }
`